import React from 'react';
import { Button } from './ui/button';
import beard from "../assets/images/g1.jpg";

const BeardStyling = () => {
  return (
    <div className="pt-20">
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Beard Styling Services</h1>
              <p className="text-gray-700 leading-relaxed mb-4">
                Expert beard grooming and styling services tailored to your face shape and personal style. Our skilled barbers provide precision trimming, shaping, and maintenance.
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                From classic styles to modern trends, we help you achieve the perfect beard look.
              </p>
              <Button
                className="bg-black hover:bg-gray-800 text-white px-8 py-4 rounded-full"
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Book Appointment
              </Button>
            </div>
            <div>
              <img src={beard} alt="Beard Styling" className="rounded-lg shadow-xl w-full h-[500px] object-cover" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BeardStyling;
